import { Field, Image, ImageField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { toKebabCase } from 'src/utils/helpers';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './IntroText.module.css';

type Fields = {
	PageImage?: Field<ImageField>;
	Strapline?: Field<string>;
	PageTitle?: Field<string>;
	NavigationLinkText?: Field<string>;
};

type IntroTextProps = ComponentProps & {
	route: {
		fields: Fields;
	};
	fields: Fields;
};

export default function IntroText(props: IntroTextProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<IntroTextProps>();
	const imageField = props.fields?.PageImage ?? sitecoreContext.route.fields.PageImage;
	const straplineField = props.fields?.Strapline ?? sitecoreContext.route.fields.Strapline;
	const pageTitle = props.fields?.PageTitle ?? sitecoreContext.route.fields.PageTitle;
	const navigationLinkText = props.fields?.NavigationLinkText ?? sitecoreContext.route.fields.NavigationLinkText;
	const image = imageField?.value as {
		alt: string;
		height: string;
		src: string;
		width: string;
	};

	const mediaWithModifiedSrc = {
		...image,
		src: process.env.PUBLIC_URL && image?.src ? image.src.replace(/^https?:\/\/[^\/]+/, process.env.PUBLIC_URL) : image?.src,
	};
	const elementId = navigationLinkText && navigationLinkText?.value ? toKebabCase(navigationLinkText.value.toLowerCase().trim()) : '';

	return (
		<>
			<Text tag="h3" id={elementId} field={navigationLinkText} className={styles.hidden} data-section-header data-display-pdf-download />
			<div className="maxWidth" data-display-pdf-download>
				<EditorHelp text="Please use image with minimum 700px width and 1.64:1 aspect ratio (slightly wider than 16:9)." />
				<div className={`${styles.hidden} padY`} id="contentTitle">
					<Text tag="h3" field={pageTitle} className={styles.contentTitleText} />
				</div>
				{imageField && (
					<div className={styles.imageContainer}>
						<Image media={mediaWithModifiedSrc} className={styles.image} />
					</div>
				)}
				<Text tag="p" field={straplineField} className={styles.strapline} />
			</div>
		</>
	);
}
